import '../GlobalPages.css';

import PizzaChart from '../../components/pizzaChart/PizzaChart';
import BarChart from '../../components/barChart/BarChart';
import { useEffect, useState } from 'react';
import Table from '../../components/table/Table';
import SearchByData from '../../components/search/bydata/SearchByData';
import Loader, { LoaderDialog } from '../../components/loader/Loader';
import { useLocation } from 'react-router-dom';
import { MessageDialog } from '../../components/messagebox/MessageBox';
import { ILineChartData } from '../../interfaces/type1/ILineChartData';
import { DateRange, ExtraParamsKeys, IExtraParams, IQueryParams } from '../../interfaces/type1/IQueryParams';
import DataFactory from '../../services/type1/DataFactory';
import LineChart from '../../components/lineChart/LineChart';
import DateUtils from '../../utils/DateUtils';
import { useHeaderOptions } from '../../components/hooks/useHeaderOptions';
import Tooltip from '../../components/tooltip/Tooltip';
import Cache from '../../components/search/Cache';
import { HeadersRoutes, INavMenuRoute } from '../../components/header/HeaderOptions';
export default function ChartPage() {

    let url = useLocation();
    let [data, setData] = useState<ILineChartData | undefined>(undefined);

    let cache = Cache.GetCache();

    let [searchParams, setSearchParams] = useState<IQueryParams>({
        DateRange: cache? DateRange.UNDEFINED : DateRange.TODAY,
        Start: cache ? DateUtils.CastStringToDate(cache.Start) : new Date(),
        End: cache ? DateUtils.CastStringToDate(cache.End) : new Date(),
        GraphicId: url.pathname,
        GraphicType: 't1'
    });

    
    
    const options = useHeaderOptions();
    
    let relatorio = options.find(r => r.URL == url.pathname);

    let graph: INavMenuRoute | undefined = HeadersRoutes.GetRoutes().FirstOrDefault(s => s.URL == relatorio?.URL);

    useEffect(() => {

        (async () => {

            let delayTask = (ms: number) => new Promise<void>((r, e) => setTimeout(() => r(), ms));

            //remover apos o Google corrigir o problema do progress bar indevido no PWA
            await delayTask(500);

            LoaderDialog.Show(
                {
                    Title: "Aguarde",
                    Message: "Consultando dados..."
                });

            await delayTask(500);

            let data: ILineChartData | undefined;

            try {

                data = await DataFactory.GetRelatorioAsync(searchParams);
                
                LoaderDialog.Close();

                if (!data || !data.DataSets.Data.Any())
                    MessageDialog.Toast("Atenção", "Nenhuma informação foi encontrada para a pesquisa realizada!");
                else {
                    if (data.DataSets.Data.Any()) {
                        setData(data);
                    }
                    else
                        setData(undefined);
                }

            } catch (e) {
                LoaderDialog.Close();
                let errorMessage = (e as Error).message;
                MessageDialog.Toast("Erro ao obter dados", errorMessage ? errorMessage : "Não foi possivel obter uma dados do servidor");
            }

        })();

    }, [searchParams]);


    let searchHandle = async (init: Date, end: Date, range: DateRange, extraParams?: IExtraParams[]) => {
        setSearchParams({
            DateRange: range,
            Start: init,
            End: end,
            GraphicId: url.pathname,
            GraphicType: 't1', 
            ExtraParams: extraParams
        });
    }

    return (
        <div className='PageComponent ChartPage'>

 <Tooltip text='Abrir o texto explicativo do gráfico' mode='RIGHT' width={200} onChildrenElementClicked={()=>{
              MessageDialog.Show({
                Message: relatorio?.Help ?? "",
                Title: "Ajuda", 
                OKText: "OK",
                OKClickEvent: ()=> {},
                IsOpen: true,
                Size: 'Large'
              })  
            }}>
            <i className="help-icon pi pi-question-circle"
            
            ></i>
            </Tooltip>

            <Loader />

            <h1 className='ReportTitleH1'>
                {relatorio?.Title}
            </h1>

            {
                graph?.ExtraParams?.Any(s => s.Key == ExtraParamsKeys.SEM_FILTRO_DATA) ? null : <SearchByData OnSearchButtonClick={searchHandle} />
            }
            

             {
                data  && data.ShowTitle && (
                    <div>
                        <h3 className='Informer'> {data.Title}</h3>
                    </div>
                )
            }

            {
                data && !data.FromWebSocket && data.CreatedAt && (
                    <div>
                        <h4 className='Informer'>Dados gerados em {DateUtils.CastDateWithTimeToString(DateUtils.CastStringToDate(data!.CreatedAt as any as string))} </h4>
                    </div>
                )
            }

            {
                data && <div className='ChartContainer'>

                    {
                        data && data.ChartType == 'Bar' ? <BarChart Data={data} /> : <LineChart Data={data} />
                    }

                </div>
            }

            {!data && <h1 className='NoContentFondH1' >Nenhuma informação foi encontrada para a pesquisa realizada!</h1>}

            {
                data && data.TableDataSet && <> <br /><Table Data={data.TableDataSet} /></>
            }


            {
                data && data.TableDataSet && <><br /><div className='ChartContainer'><PizzaChart Data={data} /></div></>
            }

            {
                data && <>
                    <h4 className='Informer ChartDescription'>{data.Description}
                    </h4><br /></>
            }

        </div>
    )
}
